module.exports = __webpack_public_path__ + "static/media/icon-user-svg.cbdc35f1.svg";